export default {
  PostCreateSidebar: false,
  ChannelCreateSidebar: false,
  reg1popup: false,
  reg1popup: false,
  loginPop: false,
};
